import { useState, useEffect } from 'react';
import { getApiUrl } from '../utils/config';

interface AITaskCost {
  task_type: string;
  cost_in_credits: number;
  display_text: string;
  show_in_pricing: boolean;
}

export const useAITaskCosts = () => {
  const [taskCosts, setTaskCosts] = useState<AITaskCost[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchTaskCosts = async () => {
      try {
        const response = await fetch(`${getApiUrl()}/api/v1/ai-task-costs/`, {
          headers: {
            'Authorization': `Bearer ${localStorage.getItem('access_token')}`,
          },
        });

        if (!response.ok) {
          throw new Error('Failed to fetch AI task costs');
        }

        const costs = await response.json();
        setTaskCosts(costs);
      } catch (err) {
        setError(err instanceof Error ? err.message : 'Unknown error');
      } finally {
        setLoading(false);
      }
    };

    fetchTaskCosts();
  }, []);

  const getTaskCost = (taskType: string): number => {
    // Special case for One-Click Creator which is hardcoded in the backend
    if (taskType === 'One-Click Creator') {
      return 15;
    }
    
    const task = taskCosts.find(t => t.task_type === taskType);
    return task ? task.cost_in_credits : 0;
  };

  return {
    taskCosts,
    loading,
    error,
    getTaskCost,
  };
};